import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const Donation = () => {
  return (
    <div className="donation-page">
      {/* Hero Section */}
      <div className="hero-section text-dark text-center py-2">
        <Container>
          <h1 className="display-5 fw-bold">एखाद्याच्या हास्याचे कारण बना.</h1>
          <p className="lead mt-3">
            दुष्काळग्रस्त भागातील शिक्षण, आरोग्यसेवा आणि पोषण याद्वारे जीवन
            उन्नत करण्याच्या आमच्या मोहिमेत सामील व्हा.
          </p>
        </Container>
      </div>

      {/* Why Donate Section */}
      <Container className="py-1">
        <Row className="text-center mb-5">
          <h2 className="text-danger fw-bold">
            मराठवाडा सामाजिक फाऊंडेशनला देणगी का द्यावी?
          </h2>
          <p className="text-muted col-md-8 fs-4 mx-auto">
            तुमच्या योगदानामुळे आम्हाला शैक्षणिक कार्यक्रम आयोजित करण्यास,
            आरोग्य शिबिरे आयोजित करण्यास आणि गरजूंना अन्न पुरवठा वाटण्यास सक्षम
            बनवले जाते.
          </p>
        </Row>

        {/* QR Code & Account Details */}
        <Row className="justify-content-center g-4 mb-4">
          <Col md={6}>
            <Card className="p-4 shadow-lg border-0 rounded qr-card">
              <h4 className="mb-3 text-success text-center">
                📱 Scan & Donate
              </h4>
              <div className="d-flex justify-content-center mb-3">
                <img
                  src="/images/qr.jpg"
                  alt="Donate QR"
                  width={290}
                  className="img-fluid"
                />
              </div>
              <p className="text-center mb-1">
                <strong>UPI ID:</strong> donate@ngo
              </p>
              <p className="text-center">
                <strong>Note:</strong> Mention your name in the UPI note to
                receive a receipt.
              </p>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="p-4 shadow-lg border-0 rounded account-card">
              <h4 className="mb-3 text-success text-center">
                🏦 Bank Account Details
              </h4>
              <div className="d-flex justify-content-center mb-3">
                <img
                  src="/bank.png"
                  alt="Donate QR"
                  width={240}
                  className="img-fluid"
                />
              </div>
              <p className="mb-1">
                <strong>Account Name:</strong> Marathwada Samajik Foundation
              </p>
              <p className="mb-1">
                <strong>Account Number:</strong> 60453742202
              </p>
              <p className="mb-1">
                <strong>Bank Name:</strong> Bank of Maharashtra
              </p>
              <p className="mb-1">
                <strong>Branch:</strong> Adgoan, Near Jatra Hotel, Nashik-3
              </p>
              <p className="mb-1">
                <strong>IFSC Code:</strong> MAHB0001628
              </p>
            </Card>
          </Col>
        </Row>

        {/* Impact Highlights */}
        {/* <Row className="text-center mt-5 g-4">
          <Col md={4}>
            <Card className="border-0 shadow-sm p-4 impact-card h-100">
              <i className="bi bi-journal-bookmark-fill display-4 text-danger"></i>
              <h5 className="mt-3 fw-bold">Free Education</h5>
              <p>
                Providing school kits & tuition to over 300 children in need.
              </p>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="border-0 shadow-sm p-4 impact-card h-100">
              <i className="bi bi-capsule-pill display-4 text-danger"></i>
              <h5 className="mt-3 fw-bold">Health Camps</h5>
              <p>Conducting monthly medical checkups in remote villages.</p>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="border-0 shadow-sm p-4 impact-card h-100">
              <i className="bi bi-egg-fried display-4 text-warning"></i>
              <h5 className="mt-3 fw-bold">Nutrition Support</h5>
              <p>
                Distributing 500+ food packets to underprivileged families
                weekly.
              </p>
            </Card>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default Donation;
